import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';

import { AppointmentPreviewItemModule } from '../appointment-preview-item/appointment-preview-item.module';
import { AppointmentPreviewListComponent } from './appointment-preview-list.component';

@NgModule({
	declarations: [AppointmentPreviewListComponent],
	imports: [
		CommonModule,
		TranslateModule,
		BrowserAnimationsModule,
		AppointmentPreviewItemModule,
	],
	exports: [AppointmentPreviewListComponent],
	providers: [],
})
export class AppointmentPreviewListModule {}
